<template>
  <div>
    <div
      v-if="!isLoading"
      class="kyc-status"
      data-test="kyc-status-for-display--tag-status"
    >
      {{ $t('kyc.kyc_status') }}
      <span
        :class="{
          'verifying': status === 'VERIFYING',
          'rejected': status === 'REJECTED',
          'approved': status === 'APPROVED'
        }"
      >
        {{ name }}
      </span>
    </div>
    <div
      v-else
      class="kyc-status"
    >
      <b-skeleton
        width="200px"
        height="30px"
      />
    </div>
    <div
      id="section-kyc-data"
      class="section-white"
    >
      <div class="columns">
        <div
          v-if="!isLoading"
          class="column is-one-fifth t-al-center"
        >
          <img
            v-if="status === 'VERIFYING'"
            src="/static/svg/kyc-verifying.svg"
            data-test="kyc-status-for-display--ic-status"
          >
          <img
            v-else-if="status === 'REJECTED'"
            src="/static/svg/kyc-request-change.svg"
            data-test="kyc-status-for-display--ic-status"
          >
          <img
            v-else-if="status === 'APPROVED'"
            src="/static/svg/kyc-approved.svg"
            data-test="kyc-status-for-display--ic-status"
          >
        </div>
        <div
          v-else
          class="column is-one-fifth t-al-center"
        >
          <b-skeleton
            width="80px"
            height="80px"
            circle=""
          />
        </div>
        <div
          v-if="!isLoading"
          class="column"
        >
          <div
            :class="[
              'kyc-status-title',
              {
                'verifying': status === 'VERIFYING',
                'rejected': status === 'REJECTED',
                'approved': status === 'APPROVED'
              }
            ]"
            data-test="kyc-status-for-display--title-status"
          >
            {{ title }}
          </div>
          <!-- v-if="status !== 'REJECTED'" -->
          <div
            class="kyc-status-sub-title"
            v-html="subtitle"
          />
          <!-- <div
            v-else
            class="kyc-status-sub-title"
          >
            <div class="mg-t-25px">
              {{ details[0].detail }}
            </div>
            <div class="mg-t-25px">
              <div class="mg-t-25px">
                {{ $t('kyc.rejected_detail_2') }}
              </div>
              <div
                class="mg-t-25px"
                v-html="$t('kyc.rejected_detail_3')"
              />
              <div class="mg-t-25px">
                {{ $t('kyc.rejected_detail_4') }}
              </div>
            </div>
          </div> -->
        </div>
        <div
          v-else
          class="column"
        >
          <b-skeleton
            height="25px"
            width="45%"
          />
          <b-skeleton height="25px"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KYCStatusForDisplay',
  props: {
    status: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    details: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.kyc-status {
  font-size: 19px;
  font-weight: bold;
  color: #000000;
  width: 100%;
  margin-bottom: 15px;
  padding: 20px;

  span {
    border-radius: 21px;
    border: solid 2px;
    font-size: 13px;
    font-weight: bold;
    padding: 10px 10px;
    margin-left: 15px;
  }
}
.verifying {
  color: #0559af;
  border-color: #0559af;
}
.approved {
  color: #43a047;
  border-color: #43a047;
}
.rejected {
  color: #dc3731;
  border-color: #dc3731;
}
.section-white {
  display: block;
  margin: 0 auto;
  padding: 50px;
  max-width: 1024px;
  width: calc(100% - 20px);
  border-radius: 3px;
  box-shadow: 0 0 6px -2px rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
}
.t-al-center {
  text-align: center;
}
.kyc-status-title {
  font-family: Roboto;
  font-size: 21px;
  font-weight: bold;
}
.kyc-status-sub-title {
  margin-top: 10px;
}
.bold {
  font-weight: bold;
}
.mg-t-25px {
  margin-top: 25px;
}
.text {
  margin: 0;
  vertical-align: top;
  font-size: 15px;
  color: #2193ff;
  font-weight: bold;
  text-decoration: underline;
  &:hover {
    color: #0079fd;
    cursor: pointer;
  }
}
/* Mobile */
@media only screen and (max-width: 768px) {
  .section-white {
    width: calc(100% - 20px);
    padding: 30px 15px;
  }
  .kyc-status-sub-title {
    text-align: center;
  }
  .kyc-status-title {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SummaryOfKYC/components/KYCStatusForDisplay.vue